import React from "react";
import { Badge, Typography, Tooltip, Tag } from "antd";
import { SettingOutlined, SafetyCertificateOutlined } from "@ant-design/icons";
import { useDroppable } from "@dnd-kit/core";
import {
  SortableContext,
  verticalListSortingStrategy,
} from "@dnd-kit/sortable";
import KanbanCard from "./KanbanCard";

const { Text } = Typography;

const KanbanColumn = ({
  id,
  title,
  color,
  items,
  machineType,
  requiresQC,
  onCardClick,
}) => {
  const { setNodeRef, isOver } = useDroppable({ id });

  return (
    <div
      className={`kanban-column ${isOver ? "kanban-column--over" : ""}`}
      style={{ borderTopColor: color }}
    >
      {/* Column header */}
      <div className="kanban-column-header">
        <div className="kanban-column-title">
          <Text strong>{title}</Text>
          <div className="kanban-column-meta">
            {machineType && (
              <Tooltip title={`Requires machine: ${machineType}`}>
                <Tag
                  icon={<SettingOutlined />}
                  style={{ fontSize: 10, marginRight: 4 }}
                >
                  {machineType}
                </Tag>
              </Tooltip>
            )}
            {requiresQC && (
              <Tooltip title="Quality check required">
                <SafetyCertificateOutlined
                  style={{ color: "#52c41a", fontSize: 13 }}
                />
              </Tooltip>
            )}
          </div>
        </div>
        <Badge
          count={items.length}
          showZero
          style={{ backgroundColor: color }}
        />
      </div>

      {/* Droppable area */}
      <div ref={setNodeRef} className="kanban-column-content">
        <SortableContext
          items={items.map((i) => i.id)}
          strategy={verticalListSortingStrategy}
        >
          {items.map((item) => (
            <KanbanCard
              key={item.id}
              item={item}
              onCardClick={onCardClick}
              isLocked={item._batchLocked === true}
            />
          ))}
        </SortableContext>

        {items.length === 0 && (
          <div className="kanban-empty">
            <Text type="secondary">No jobs</Text>
          </div>
        )}
      </div>
    </div>
  );
};

export default KanbanColumn;
